import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'

// Packages
import { reduxForm, Field, FieldArray } from 'redux-form'

// Helpers
import { required } from '../../../../../utils/formValidators'

// Form Components
import ReduxFormInput from '../../../../../components/Global/ReduxForms/ReduxFormInput'

class LockerCampsForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    participation: PropTypes.object.isRequired
  }

  render() {
    return(
      <form onSubmit={this.props.handleSubmit}>
        <FieldArray
          name="camps"
          component={renderCamps}
        />
        <hr/>
        <button className="cta-gradient" type="submit">
          Save Changes
        </button>
      </form>
    )
  }
}

const renderCamps = ({ fields }) => (
  <ul>
    {
      fields.map((camp, index) => (
        <li key={index}>
          <Field
            name={camp}
            type="text"
            component={ReduxFormInput}
            validate={required}
            placeholder="Enter a camp name"
            handleInputRemoval={() => fields.remove(index)}
          />
        </li>
      ))
    }
    <li>
      <button type="button" className="cta invert" onClick={() => fields.push("")}>
        + Add a Camp
      </button>
    </li>
  </ul>
)

// Connect to redux-form
LockerCampsForm = reduxForm({
  form: 'LockerCampsForm'
})(LockerCampsForm)


// Connect to redux
const mapStateToProps = (state, ownProps) => {
  const { camps } = ownProps.participation

  return ({
    initialValues: {
      camps: camps.length > 0 ? camps : ['']
    }
  })
}

export default connect(mapStateToProps)(LockerCampsForm)



// WEBPACK FOOTER //
// ./src/screens/UserPortal/Locker/LockerScreens/LockerCampsForm/LockerCampsForm.js